<div class="score-bar" [style.--score-color]="'var(' + colorVar() + ')'">
  <span class="label">{{ label() }}</span>
  <div class="track">
    <div class="fill" [style.width.%]="fillPercent()"></div>
  </div>
  <span class="value" [class.suspended]="isRatingSuspended()"
    ><span class="value-number">{{ isRatingSuspended() ? '?' : value() }}</span
    >/<span class="max-number">{{ max() }}</span></span
  >
</div>
